import {client} from './utils/ApiClient'
import {LOCAL_STORAGE_KEY} from './constants/localStorage'
import { DEBUG_FLAG } from './constants/debug';

async function getToken() {
  // TODO: on mobile Device do DeviceAuth and try to get AccessToken
  const token = window.sessionStorage.getItem(LOCAL_STORAGE_KEY.accessToken);
  return(token);
}

function handleUserResponse({user, deviceId}) {
  window.sessionStorage.setItem(LOCAL_STORAGE_KEY.accessToken, user.token);
  if (user.refreshToken) {
    window.localStorage.setItem(LOCAL_STORAGE_KEY.refreshToken, user.refreshToken);
  }
  if (deviceId) {
    if (DEBUG_FLAG()) {
      window.localStorage.setItem(LOCAL_STORAGE_KEY.deviceIdLocal, deviceId);
    } else {
      window.localStorage.setItem(LOCAL_STORAGE_KEY.deviceId, deviceId);
    }
  }
  return user
}

async function login(form) {
  const result_1 = await client('login', { data: form });
  return handleUserResponse(result_1);
}

async function loginAdmincode(form) {
  const result_1 = await client('login/admincode', { data: form });
  return handleUserResponse(result_1);
}

async function refreshToken(form) {
  const token = window.localStorage.getItem(LOCAL_STORAGE_KEY.refreshToken);
  const result = await client('token/refresh', { data: form, token: token });
  console.log(result);
  return handleUserResponse(result);
}

async function logout() {
  window.sessionStorage.removeItem(LOCAL_STORAGE_KEY.accessToken);
  const saveUsername = window.localStorage.getItem(LOCAL_STORAGE_KEY.saveUsername);
  if (saveUsername === 'false') {
    window.localStorage.removeItem(LOCAL_STORAGE_KEY.username);
  } 
}

async function logoutRefreshToken() {
  window.localStorage.removeItem(LOCAL_STORAGE_KEY.refreshToken);
}

export {getToken, login, loginAdmincode, logout, refreshToken, logoutRefreshToken}